module.exports = __webpack_public_path__ + "static/media/pain.ea38bc46.svg";